<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title class="error headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
    <v-card-text>Are you sure you want to remove planning {{ hspl.plan_code }}  from the accommodation {{hspl.huis_code}} ?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="error mx-2" small @click="rmHspl">Yes</v-btn>
      <v-btn color="success"  small @click="dialog = false">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
// import {bus} from "../../../main";
export default {
  data() { 
    return {
      dialog: false,
      hspl_encrid: null,
      hspl: {}
    }
  },
  methods: {
    open(hspl_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huis/hspl/getHspl.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHspl"
          },
          getHspl: {
            hspl_encrid: hspl_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hspl = res.data.getHspl;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rmHspl() { 
      this.$axios
        .post("ares/json/ares/huis/hspl/rmHspl.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "rmHspl"
          },
          rmHspl: {
            hspl_encrid: this.hspl.hspl_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             //this.$router.reload('/huis/onHuis/' + res.data.rmHspl.huis_encrid); 
            //  bus.$emit("closeDialog", "reload");
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.rmHspl.text,
              color: res.data.rmHspl.color
            });
            this.$emit('updateData');
            this.dialog = false;
          }
        })
    },
  }
}
</script>

